import { usePlaybackIsSeeking, usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { useCallback } from 'react';
import { useStreamSettingsStore } from '../../stores/stream-screen-settings.store';
import { useSetCursor } from '../../stores/stream-screen.store';

export function useSetCursorAndPlay() {
  const setCursor = useSetCursor();
  const play = usePlaybackPlay();
  const isSeeking = usePlaybackIsSeeking();
  const playOnCursorSet = useStreamSettingsStore((state) => state.playOnCursorSet);

  return useCallback(
    (ts: number) => {
      setCursor(ts);

      // Skip if a seek is already in progress to avoid stacking rapid seeks
      // that exhaust the hls.js buffer and produce a loading spinner.
      if (playOnCursorSet && !isSeeking) {
        play({
          startTs: ts,
        });
      }
    },
    [setCursor, play, playOnCursorSet, isSeeking],
  );
}
